/**
 * Convert 24-hour time format to 12-hour format with AM/PM
 * @param {string} time24 - Time in 24-hour format (e.g., "14:00", "09:30")
 * @returns {string} Time in 12-hour format (e.g., "2:00 PM", "9:30 AM")
 */
export const formatTime12 = (time24) => {
  if (!time24) return '';
  
  const [hours, minutes] = time24.split(':').map(Number);
  const period = hours >= 12 ? 'PM' : 'AM';
  const hours12 = hours % 12 || 12; // Convert 0 to 12 for midnight
  
  return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
};

/**
 * Format a time range in 12-hour format
 * @param {string} startTime - Start time in 24-hour format
 * @param {string} endTime - End time in 24-hour format
 * @returns {string} Formatted time range (e.g., "9:00 AM - 5:00 PM")
 */
export const formatTimeRange = (startTime, endTime) => {
  return `${formatTime12(startTime)} - ${formatTime12(endTime)}`;
};
